import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { Reveal } from "../site/Motion";

export const HiringBanner = () => (
  <section className="border-y hairline bg-[var(--ink-2)]" data-testid="home-hiring-section">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-24 grid lg:grid-cols-12 gap-10 items-center">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow flex items-center gap-2"><Users className="w-4 h-4" /> We're Hiring — Join Selby Asset Group</p>
        <h2 className="font-display text-4xl md:text-6xl text-slate-50 mt-5 leading-[1]">Build Your Career <em className="text-gold">With Us.</em></h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7 space-y-4 text-slate-300 leading-relaxed">
        <p className="text-base md:text-lg text-slate-200">Selby Asset Group is growing, and we are looking for motivated, talented, and dependable professionals to join our team.</p>
        <p>We are currently accepting applications across multiple departments, including administration, management, finance, sales, business development, human resources, procurement, logistics, operations, and transportation.</p>
        <p>If you are passionate about your work and interested in becoming part of a growing organization, we invite you to explore our current employment opportunities.</p>
        <Link to="/careers" className="btn-gold mt-4 inline-flex" data-testid="home-explore-careers-button">Explore Career Opportunities <ArrowRight className="w-4 h-4" /></Link>
      </Reveal>
    </div>
  </section>
);
